import './Settings.scss'

import React, {Component} from 'react';

import { push } from 'react-router-redux'

const Settings = ({children}) => {
  return (
    <div className="Settings">
      { children }
    </div>
  )
}

export default Settings
